// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* width */
::-webkit-scrollbar {
  width: 7px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(57, 57, 57, 1);
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(28, 28, 28, 1);
  border-radius: 10px;
}

:root{
  /* Primary Font Family*/
  --primary-font: "Golos Text", sans-serif;
  
  /* Global background color */
  --background-color-primary: #000000;
  --background-color-secondary: #fff;

   /* Global text color */
  --color-text-primary: #FFFFFF;
  --color-text-secondary: #969EAA;
  --color-text-third: #7D8187;

  /* Global Font */
  --font-size-title-xl: 110px;
  --font-size-sub-title-xl: 70px;
  --font-size-sub-title-l: 20px;
  --font-size-body-l: 22px;
  --font-size-body-md: 18px;
  --font-size-body-sm: 16px;
  --font-size-body-ssm: 14px;
  --font-size-sssm: 12px;

  /* Input Color */
  --color-input-field-default: #7D8187;
  --color-input-hover: #9EA0A4;
  --color-input-bg-dropdown: #191919;
  --color-input-bg-dropdown-hover: #393939;

  /* Toast color */
  --color-toast-success: #84A578;
  --color-toast-warning: #FFC18E;
  --color-toast-error: #F8868A;

  /* Global Responsive Value */
  --global-desktop-width-resp: 1923px;
  --global-laptop-width-resp: 1728px;
  --global-tablet-width-resp: 850px;
  --global-mobile-width-resp: 440px;

      /* ----Responsive desktop---- */
  --global-desktop-padding-left: 400px;
  --global-desktop-padding-right: 400px;

      /* ----Responsive Laptop---- */
    
  --global-laptop-padding-left: 300px;
  --global-laptop-padding-right: 300px;

      /* ----Responsive Tablet---- */
  --global-tablet-padding-left: 32px;
  --global-tablet-padding-right: 32px;

        /* ----Responsive Mobile---- */
  --global-mobile-padding-left: 15px;
  --global-mobile-padding-right: 15px;

  --global-mobile-text-tittle-xl: 34px;
}

html, body {
  font-family: var(--primary-font);
  font-weight: 400;
  font-style: normal;
  margin: 0;
  background-color: #000000;
  color: #ffffff;
  --sb-track-color: #232e33;
  --sb-thumb-color: #ffffff;
  --sb-size: 1px;
  box-sizing: border-box;
  overscroll-behavior: none;
  -webkit-overflow-scrolling: auto;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,UAAU;AACV;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;;EAExC,4BAA4B;EAC5B,mCAAmC;EACnC,kCAAkC;;GAEjC,sBAAsB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;;EAE3B,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;EAC9B,6BAA6B;EAC7B,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;;EAEtB,gBAAgB;EAChB,oCAAoC;EACpC,4BAA4B;EAC5B,kCAAkC;EAClC,wCAAwC;;EAExC,gBAAgB;EAChB,8BAA8B;EAC9B,8BAA8B;EAC9B,4BAA4B;;EAE5B,4BAA4B;EAC5B,mCAAmC;EACnC,kCAAkC;EAClC,iCAAiC;EACjC,iCAAiC;;MAE7B,+BAA+B;EACnC,oCAAoC;EACpC,qCAAqC;;MAEjC,8BAA8B;;EAElC,mCAAmC;EACnC,oCAAoC;;MAEhC,8BAA8B;EAClC,kCAAkC;EAClC,mCAAmC;;QAE7B,8BAA8B;EACpC,kCAAkC;EAClC,mCAAmC;;EAEnC,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC","sourcesContent":["/* width */\n::-webkit-scrollbar {\n  width: 7px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px rgba(57, 57, 57, 1);\n  border-radius: 10px;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: rgba(28, 28, 28, 1);\n  border-radius: 10px;\n}\n\n:root{\n  /* Primary Font Family*/\n  --primary-font: \"Golos Text\", sans-serif;\n  \n  /* Global background color */\n  --background-color-primary: #000000;\n  --background-color-secondary: #fff;\n\n   /* Global text color */\n  --color-text-primary: #FFFFFF;\n  --color-text-secondary: #969EAA;\n  --color-text-third: #7D8187;\n\n  /* Global Font */\n  --font-size-title-xl: 110px;\n  --font-size-sub-title-xl: 70px;\n  --font-size-sub-title-l: 20px;\n  --font-size-body-l: 22px;\n  --font-size-body-md: 18px;\n  --font-size-body-sm: 16px;\n  --font-size-body-ssm: 14px;\n  --font-size-sssm: 12px;\n\n  /* Input Color */\n  --color-input-field-default: #7D8187;\n  --color-input-hover: #9EA0A4;\n  --color-input-bg-dropdown: #191919;\n  --color-input-bg-dropdown-hover: #393939;\n\n  /* Toast color */\n  --color-toast-success: #84A578;\n  --color-toast-warning: #FFC18E;\n  --color-toast-error: #F8868A;\n\n  /* Global Responsive Value */\n  --global-desktop-width-resp: 1923px;\n  --global-laptop-width-resp: 1728px;\n  --global-tablet-width-resp: 850px;\n  --global-mobile-width-resp: 440px;\n\n      /* ----Responsive desktop---- */\n  --global-desktop-padding-left: 400px;\n  --global-desktop-padding-right: 400px;\n\n      /* ----Responsive Laptop---- */\n    \n  --global-laptop-padding-left: 300px;\n  --global-laptop-padding-right: 300px;\n\n      /* ----Responsive Tablet---- */\n  --global-tablet-padding-left: 32px;\n  --global-tablet-padding-right: 32px;\n\n        /* ----Responsive Mobile---- */\n  --global-mobile-padding-left: 15px;\n  --global-mobile-padding-right: 15px;\n\n  --global-mobile-text-tittle-xl: 34px;\n}\n\nhtml, body {\n  font-family: var(--primary-font);\n  font-weight: 400;\n  font-style: normal;\n  margin: 0;\n  background-color: #000000;\n  color: #ffffff;\n  --sb-track-color: #232e33;\n  --sb-thumb-color: #ffffff;\n  --sb-size: 1px;\n  box-sizing: border-box;\n  overscroll-behavior: none;\n  -webkit-overflow-scrolling: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
